import { Box } from "./heartStyle";
import { usePosts } from "../../providers/Posts";
import { useCases } from "../../providers/Cases";
import { useCategories } from "../../providers/Categories";

const Heart = ({ textDisplay }) => {
  const { setShowPost, showPost } = usePosts();
  const { showCases, setShowCaseDesc } = useCases();

  const { setShowCategory } = useCategories();

  const back = () => {
    setShowPost(false);
  };

  return (
    <Box
      id="heart"
      onClick={() =>
        showCases
          ? setShowCaseDesc(false)
          : showPost
          ? back()
          : setShowCategory(false)
      }
    >
      {typeof textDisplay === "string" ? (
        <h1 dangerouslySetInnerHTML={{ __html: textDisplay }} />
      ) : (
        <img
          src={
            "https://sli.lbca.com.br/wp-content/uploads/2023/11/cropped-sli-lbca-1.png"
          }
          alt="Logo LegalBox"
        />
      )}
    </Box>
  );
};

export default Heart;
